<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div [formGroup]="group">
  <profile-pds-p-select
    p-select
    [id]="'autocomplete-' + model.id"
    [name]="'autocomplete-' + model.id"
    [label]="model.label ?? undefined"
    [required]="model.required"
    [formControlName]="model.id"
    [attr.data-protractor-id]="'autocomplete-' + id"
    (change)="onChange($event)"
    (toggle)="onToggle($event)"
  >
    <profile-pds-p-input-search
      p-input-search
      slot="filter"
      name="search"
      [value]="searchValue()"
      [loading]="loading()"
      [clear]="true"
      [indicator]="true"
      [compact]="true"
      [autoComplete]="'off'"
      [id]="'autocomplete-search-' + model.id"
      [name]="'autocomplete-' + model.name"
      (input)="onInput($event)"
      (blur)="$event.stopPropagation()"
      (change)="$event.stopPropagation()"
    ></profile-pds-p-input-search>

    @if (initialLoading()) {
      <div
        slot="options-status"
        class="profile:text-contrast-medium profile:cursor-not-allowed profile:py-static-sm profile:px-[12px]"
        role="status"
        aria-live="polite"
      >
        <span>{{ 'pidpaw.editAddress.input.address.initialLoading' | translate }}</span>
      </div>
    }

    @if (loading() && !error()) {
      <div slot="options-status" role="status" aria-live="polite" aria-busy="true">
        <span class="profile:sr-only">{{ 'pidpaw.editAddress.input.address.loading' | translate }}</span>
        <div class="profile:skeleton profile:h-10" aria-hidden="true"></div>
      </div>
    }

    @for (option of options(); track option.value) {
      <profile-pds-p-select-option p-select-option [value]="option.value">
        {{ option.label }}
      </profile-pds-p-select-option>
    }

    <!-- No filter results -->
    @if (!initialLoading() && !loading() && options().length === 0 && !error()) {
      <div
        slot="options-status"
        class="profile:text-contrast-medium profile:cursor-not-allowed profile:py-static-sm profile:px-[12px]"
        role="status"
        aria-live="polite"
      >
        <span>{{ 'pidpaw.editAddress.input.address.emptyResult' | translate }}</span>
      </div>
    }

    <!-- Error state -->
    @if (error()) {
      <div
        slot="options-status"
        class="profile:flex profile:gap-static-sm profile:py-static-sm profile:px-[12px]"
        role="alert"
        aria-live="assertive"
      >
        <profile-pds-p-icon p-icon name="information" color="error" aria-hidden="true"></profile-pds-p-icon>
        <span class="profile:text-error">{{ 'pidpaw.editAddress.error.backend.default' | translate }}</span>
      </div>
    }
  </profile-pds-p-select>
</div>
